import axios from 'axios'
import {
  CreateTransitOperationInfoRequest,
  TransitOperationInfoResponse,
  UpdateReviewRequest,
} from '../../../../../api/models'
import { UserFeedbackRequestWithCancellationReason } from '../models/mapper'

const apiUrl = process.env.REACT_APP_API_URL
const baseUrl = `${apiUrl}/v2/transit-operation-info`

export async function fetchTransitOperationInfoV2(id: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<TransitOperationInfoResponse>(`${baseUrl}/${id}`, {
    signal: opts?.signal,
  })
  return data
}

export async function createTransitOperationInfoV2(data: CreateTransitOperationInfoRequest) {
  const response = await axios.post<TransitOperationInfoResponse>(baseUrl, data)
  return response.data
}

export async function sendUserFeedbackV2(id: number, data: UserFeedbackRequestWithCancellationReason) {
  await axios.patch<void>(`${baseUrl}/feedback/${id}`, data)
}

export async function updateReviewStatusV2(id: number, data: UpdateReviewRequest) {
  const response = await axios.patch<TransitOperationInfoResponse>(`${baseUrl}/review-status/${id}`, data)
  return response.data
}
